import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/firestore";
import "firebase/messaging";
import "firebase/analytics";
import "firebase/storage";

const config = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,

  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMIAN,

  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,

  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,

  ...(process.env.REACT_APP_FIREBASE_DATABASE_URL != null && {
    databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  }),
};

function initFireBase() {
  if (!firebase.apps.length) {
    firebase.initializeApp(config);
    firebase.analytics();
  }
}
initFireBase();

export { firebase };
